module.exports = __webpack_public_path__ + "assets/img/fbf48de1217591f5a5f6d2d4c13022d6.png";